import contracttemplate from './contract.tpl.html';

export class Contract {
  constructor($scope, $ngRedux, actionsFactory, $translate) {
    Object.assign(this, {
      $scope,
      $ngRedux,
      actionsFactory,
      $translate,
    });
    const unsubscribe = $ngRedux.connect(this.mapStateToThis, actionsFactory)(this);
    $scope.$on('$destroy', unsubscribe);
  }

  goTo(dest) {
    this.state(dest);
  }

  logout() {
    this.reqLogout();
  }

  /* eslint-disable */
  mapStateToThis(state) {
    return {
      auth: state.auth,
      };
  }
  /* eslint-enable */
}

Contract.$inject = [
  '$scope',
  '$ngRedux',
  'actionsFactory',
  '$translate',
];

export const contract = {
  template: contracttemplate,
  controller: Contract,
};
